import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { KeyboardEvent, memo, useCallback } from 'react';

import { MultiStorePointOfSale } from '../../../../interface/multi-store';
import { handleActivationKey } from './multi-store-a11y';
import { MultiStoreCardFrame } from './multi-store-card-frame';
import { MultiStoreCenterContent } from './multi-store-center-content';

interface MultiStorePanelCardProps {
  pointOfSale: MultiStorePointOfSale;
  isSelected: boolean;
  // massimo raggiunto: la scheda non si seleziona finché non se ne toglie un'altra
  isDisabled: boolean;
  onToggle: (pointOfSaleId: string) => void;
}

// Scheda di un centro candidato: tutta la scheda aggiunge o toglie il centro dalla bozza
export const MultiStorePanelCard = memo(function MultiStorePanelCard({
  pointOfSale,
  isSelected,
  isDisabled,
  onToggle,
}: MultiStorePanelCardProps): JSX.Element {
  const handleToggle = useCallback(() => {
    if (!isDisabled) onToggle(pointOfSale.id);
  }, [isDisabled, onToggle, pointOfSale.id]);

  const handleKeyDown = useCallback(
    (event: KeyboardEvent<HTMLDivElement>) => {
      handleActivationKey(event, handleToggle);
    },
    [handleToggle]
  );

  return (
    <div
      role="checkbox"
      aria-checked={isSelected}
      aria-disabled={isDisabled}
      tabIndex={0}
      className="multi-store-card-target"
      onClick={handleToggle}
      onKeyDown={handleKeyDown}
    >
      <MultiStoreCardFrame isSelectable isActive={isSelected}>
        <MultiStoreCenterContent
          pointOfSale={pointOfSale}
          isOrigin={false}
          distance={pointOfSale.distance}
          adornment={
            isSelected ? (
              <CheckCircleIcon color="primary" />
            ) : (
              <AddCircleOutlineOutlinedIcon
                color={isDisabled ? 'disabled' : 'primary'}
              />
            )
          }
        />
      </MultiStoreCardFrame>
    </div>
  );
});
